import { Loader } from "@googlemaps/js-api-loader";

let loaderPromise = null;

export const loadGoogleMaps = () => {
  if (typeof window === "undefined") return Promise.resolve(null);

  // ✅ If already loaded, resolve immediately
  if (window.google?.maps?.drawing) {
    return Promise.resolve(window.google.maps);
  }

  if (!loaderPromise) {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

    if (!apiKey) {
      console.error("❌ Google Maps API key missing");
      return Promise.reject(new Error("Google Maps API key missing"));
    }

    const loader = new Loader({
      apiKey,
      version: "weekly",
      libraries: ["drawing", "places", "geometry"], // ✅ YEH LINE IMPORTANT HAI
      language: "en",
      region: "US",
      id: "google-maps-script",
    });

    loaderPromise = loader
      .load()
      .then((google) => {
        console.log("✅ Google Maps loaded");
        return google.maps;
      })
      .catch((error) => {
        console.error("❌ Google Maps error:", error);
        loaderPromise = null;
        throw error;
      });
  }

  return loaderPromise;
};